<template>
  <div>
    <Header :title="'个人中心'"/>
    <div class="logo-containers">
      <van-row type="flex" justify="center">
        <van-col span="4"></van-col>
        <van-col span="8"><van-icon name="manager-o" size="60px" color="#00b949"/></van-col>
        <van-col span="4"></van-col>
      </van-row>
      <div class="gap"></div>
      <van-row type="flex" justify="center">
        <van-col span="1"></van-col>
        <van-col span="20">
          <div>
            {{userinfo.orga.name}}
          </div>
          <div class="info">
            <div>
              客户有效期：{{userinfo.updateDate}}
            </div>
          </div>
        </van-col>
        <van-col span="1"></van-col>
      </van-row>
    </div>
    <div class="login-input-containers">
      <div class="logo-containers">
        <van-row type="flex" justify="center">
          <van-col span="6"></van-col>
          <van-col span="12"><van-button color="#004099" type="primary" plain @click="loginout" block>退出登录</van-button></van-col>
          <van-col span="6"></van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import { Col, Row,Field,CellGroup,Button,Icon,Dialog} from 'vant';
import Header from '../../components/backheader.vue'
import { mapState } from 'vuex'
  export default {
     computed: {
      ...mapState({
      'userinfo': state=>state.user.userinfo
      })
    },
    components : {
        Header,
      [Row.name]:Row,
      [Col.name]:Col,
      [Field.name]:Field,
      [CellGroup.name]:CellGroup,
      [Icon.name]:Icon,
      [Dialog.Component.name]:Dialog,
      [Button.name]:Button
    },
    mounted(){
      console.log([Row.name])
    },
    data(){
      return {

      }
    },
    methods : {
      loginout(){
        Dialog.confirm({
          title: '标题',
          message: '确定要退出登录吗'
        }).then(() => {
          this.logoutcomfirm()
        }).catch(() => {
          // on cancel
        });
      },
      logoutcomfirm(){
        this.$cookies.remove('status')
        localStorage.clear()
        this.$router.push({
          path : '/'
        })
      }
    }
  }
</script>

<style scoped>
.logo-containers{
  padding-bottom : 60px;
  text-align : center;
  height : 105px;
  margin-top : 100px;
}
.gap{
  height : 20px;
}
.info{
  padding-top : 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/personalcenter/index.vue